import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../../store'
import { updateTemplate } from '../../../store/templates/actions'
import { IStore } from '../../../store/types'
import { TamplateForm } from '../../../components/Templates/TamplateForm'
import { ITemplate } from '../../../store/templates/types'

export const OnlineEditTamplate: React.FC = () => {
  const [template, setTemplate] = React.useState<ITemplate | null>(null)

  const { id } = useParams()

  const { templates, products } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (id && templates.currentGroup) {
      const template = templates.currentGroup.templates.find((template) => template.absnum === Number(id))
      if (template) {
        setTemplate(template)
      }
    }
  }, [id, templates.currentGroup])

  const handleCreate = (
    values: { group_id?: number | undefined; product_id: number; message: string },
    callback: (success: boolean) => void
  ) => {
    dispatch(
      updateTemplate({
        id: Number(id),
        data: values,
      })
    ).then((res) => {
      if (res.meta.requestStatus !== 'fulfilled') {
        callback(false)
      } else {
        callback(true)
      }
    })
  }

  if (!templates.currentGroup || !template) return null

  return (
    <TamplateForm
      title={`Група ${templates.currentGroup.name}. Шаблон`}
      data={template}
      groupId={templates.currentGroup.absnum}
      products={products.products}
      createTemplate={handleCreate}
    />
  )
}
